export function makeHttpRequest(url: string): Promise<string> {
  return new Promise<string>((resolve, reject) => {
    const xmlHttp = new XMLHttpRequest();

    xmlHttp.onreadystatechange = (): void => {
      if (xmlHttp.readyState !== 4) return;

      if (xmlHttp.status === 200) {
        resolve(xmlHttp.responseText);
      } else {
        reject(new Error(`${xmlHttp.status}`));
      }
    };

    xmlHttp.open('GET', url, true);
    xmlHttp.send(null);
  });
}
